/**
 * 官网医师（匿名接口，无需 token）
 * @returns {Promise<Array>}
 */
export function fetchPublicDoctors() {
  const prefix = process.env.VUE_APP_BASE_API || ''
  return fetch(prefix + '/web/doctor/public/list', {
    method: 'GET',
    headers: { Accept: 'application/json' },
  })
    .then((res) => res.json())
    .then((body) => {
      if (body.code !== 200) {
        throw new Error(body.msg || '加载失败')
      }
      return Array.isArray(body.data) ? body.data : []
    })
}

/** 首页医师区块：status=1 且 show_on_home=1 */
export function fetchHomeDoctors() {
  const prefix = process.env.VUE_APP_BASE_API || ''
  return fetch(prefix + '/web/doctor/public/home', {
    method: 'GET',
    headers: { Accept: 'application/json' },
  })
    .then((res) => res.json())
    .then((body) => {
      if (body.code !== 200) {
        throw new Error(body.msg || '加载失败')
      }
      return Array.isArray(body.data) ? body.data : []
    })
}
